import { extend } from "./tools/helper";

import { chartTypes as plugins } from "./plugins/chartModules";

const builtin = {};

export function get() {
    return extend(builtin, plugins);
}
//# sourceMappingURL=chartModule.js.map